import styled from 'styled-components';
import Button from 'shared/ui/Button';
import BaseCancelButton from 'shared/ui/CancelButton';

export const ButtonsWrapper = styled.div`
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
  & > *:not(:first-child) {
    margin-left: 8px;
  }
`;
ButtonsWrapper.displayName = 'ButtonsWrapper';

export const Cancel = styled(BaseCancelButton)`
`;
Cancel.displayName = 'Cancel';

export const Done = styled(Button)`
`;
Done.displayName = 'Done';
